<google-chart [type]="chartType" [data]="myData" [options]="options" [style]="cStyle"></google-chart>